import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import { ScoreDetailService } from 'services';

const SoccerTimeLineStore = () => {
  const store = useLocalStore(() => ({
    timeLine: [],
    get eventType() {},
    async getBrodcasts(id) {
      const result = await ScoreDetailService.getBroadcastsBySportsType('soccer', id);

      if (result.length > 0) {
        store.timeLine = result
      }
    }
  }));

  return {
    getBrodcasts: store.getBrodcasts,
    timeLine: useObserver(() => {
      return store.timeLine.toJS();
    })
  };
};

export default SoccerTimeLineStore;
